import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  feeDetails,
  installmentDetails,
  studentInformation,
} from "src/core/statics/bill-data/bill-data";

function BillComponent() {
  const { i18n, t } = useTranslation();
  const [toggleStyle, setToggleStyle] = useState<boolean>(true);
  const studentInformationData = studentInformation;
  const feeDetailsData = feeDetails;
  const installmentData = installmentDetails;
  return (
    <div className="flex flex-col w-[569px] mobile:w-[calc(100vw-42px)]">
      <div className="flex flex-row justify-between items-center w-full mobile:flex mobile:flex-col mt-6">
        <div className="flex font-ar text-sm text-black pt-1 mobile:place-self-start mobile:mb-6">
          {t("bill.component.paymentDetails")}
        </div>
        {/* cash / installment switch button */}
        <div className="flex flex-row justify-center items-center gap-1">
          <div
            onClick={() => {
              setToggleStyle(true);
            }}
            className={`${
              toggleStyle
                ? "text-mint-500 border-mint-500 p-1.5 rounded-full"
                : `${
                    i18n.language === "ar"
                      ? "pl-4 -ml-[15px] rounded-r-full border-l-transparent"
                      : "pr-4 -mr-[15px] rounded-l-full border-r-transparent"
                  } text-neutral-400 border-[#EAEDF1] p-1.5`
            } font-ar text-xs border cursor-pointer`}
          >
            {t("bill.component.cash")}
          </div>
          <div
            onClick={() => {
              setToggleStyle(false);
            }}
            className={`${
              toggleStyle
                ? `${
                    i18n.language === "ar"
                      ? "pr-4 -mr-[15px] rounded-l-full border-r-transparent"
                      : "pl-4 -ml-[15px] rounded-r-full border-l-transparent"
                  } text-neutral-400 border-[#EAEDF1] p-1.5`
                : "text-mint-500 border-mint-500 p-1.5 rounded-full"
            } font-ar text-xs border cursor-pointer`}
          >
            {t("bill.component.payInInstallments")}
          </div>
        </div>
      </div>
      <div className="w-full h-[1px] bg-[#8E98A1] mt-6 mb-4"></div>
      <div className="font-ar text-black text-sm">
        {t("bill.component.studentInformation")}
      </div>
      <div className="flex flex-col gap-3">
        <div className="font-arLight text-sm text-neutral-700 pt-4">
          {i18n.language === "ar"
            ? studentInformationData.name
            : studentInformationData.nameEn}
        </div>
        <div className="font-arLight text-sm text-neutral-700">
          {i18n.language === "ar"
            ? studentInformationData.educationLevel
            : studentInformationData.educationLevelEn}
        </div>
        <div className="font-arLight text-sm text-neutral-700">
          {studentInformationData.phone}
        </div>
      </div>
      <div className="w-full h-[1px] bg-[#EAEDF1] mt-6 mb-4"></div>
      <div className="font-ar text-black text-sm mb-4">
        {t("bill.component.fees")}
      </div>
      {feeDetailsData.map((item, index) => (
        <div key={index} className="flex flex-row justify-between pb-4">
          <div className="text-neutral-800 font-arLight text-xs">
            {i18n.language === "ar" ? item.title : item.titleEn}
          </div>
          <div className="flex flex-row gap-1 text-zinc-800 text-xs font-arBold">
            {item.price}
            <p className="text-[8px]">{t("filterResult.component.riyal")}</p>
          </div>
        </div>
      ))}
      <div className="w-full h-[1px] bg-[#EAEDF1] mt-2"></div>
      {!toggleStyle && (
        <div className="flex flex-col border-b border-dashed border-b-[#8E98A1]">
          <div className="font-ar text-black text-sm mt-7 mb-6">
            {t("bill.component.installments")}
          </div>
          {installmentData.map((item, index) => (
            <div key={index} className="flex flex-row justify-between pb-2">
              <div className="text-neutral-800 font-arLight text-xs">
                {i18n.language === "ar" ? item.title : item.titleEn}
              </div>
              <div className="flex flex-row gap-1 text-zinc-800 text-xs font-arBold">
                {item.price}
                <p className="text-[8px]">
                  {t("filterResult.component.riyal")}
                </p>
              </div>
            </div>
          ))}
        </div>
      )}
      <div className="flex flex-row justify-between py-14">
        <div className="font-arLight text-neutral-800 text-base">
          {t("bill.component.totalPrice")}
        </div>
        <div className="text-green-500 font-arBold">
          20,000 {t("filterResult.component.riyal")}
        </div>
      </div>
    </div>
  );
}

export default BillComponent;
